/// <reference path="../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export var getDealerwareWebComponentsModule: () => ng.IModule = () => {
        return angular.module("dealerware.web.components");
    }
}
